import { zfUtils } from "./zf_utils";
import { zfc } from "./zfc_global";
export class zfcll {
    static init() {
        try {
            zfcll.linkListsAccordions =
                $(".zfcll-link-list").find(".zfcacc-accordion");
            zfc.onMatch({
                maxWidth: 720,
                callback: function () {
                    zfcll.linkListsAccordions.removeClass("zfcacc-accordion-disabled");
                },
            });
            zfc.onMatch({
                minWidth: 721,
                callback: function () {
                    zfcll.linkListsAccordions.addClass("zfcacc-accordion-disabled");
                    zfcll.linkListsAccordions
                        .find(".zfcacc-accordion-section-content")
                        .css({ display: "" });
                    zfcll.linkListsAccordions
                        .find(".zfcacc-item")
                        .removeClass("zfcacc-toggled");
                },
            });
        }
        catch (err) {
            console.log("Initalization failed: zfcll.init() " + err.message);
        }
    }
}
try {
    zfUtils.onReady(zfcll.init);
}
catch (err) {
    console.log("Initalization failed: zfcll.init() " + err.message);
}
